import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class BreakModalService {

  constructor(private http: HttpClient) { }


  addDriverBreak(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.DRIVER_BREAK, payload).pipe(
      catchError(errorHandl)
    );
  }

  getDriverBreaks(){
    return this.http.get<any>(urls.BASE_URL + urls.DRIVER_BREAK).pipe(
      catchError(errorHandl)
    );
  }

  getDriverBreaksByID(driverId){
    return this.http.get<any>(urls.BASE_URL + urls.DRIVER_BREAK +'/'+ driverId).pipe(
      catchError(errorHandl)
    );
  }

}





